import type { AlertProps } from "@mui/material"
import { Alert, AlertTitle } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import React from "react"

import { classNames } from "@/utils/utils"

export interface InformationMissingAlertProps extends Omit<AlertProps, "title"> {
  title?: string
  description?: string
  titleClassName?: string
}

export const InformationMissingAlert = React.forwardRef<HTMLDivElement, InformationMissingAlertProps>(
  ({ title, description, children, className, titleClassName, icon, ...alertProps }, ref) => {
    return (
      <Alert
        variant='filled'
        severity='info'
        className={className}
        ref={ref}
        icon={icon ?? <WarningOutlined color='primary' />}
        {...alertProps}
      >
        {title && <AlertTitle className={titleClassName}>{title}</AlertTitle>}
        {description && <p className={classNames("text-sm", { "mb-3": !!children })}>{description}</p>}
        {children}
      </Alert>
    )
  }
)
